import type { IBaseNotary } from "../../BaseNotaryFactory";
import type { File } from "le-coffre-resources/dist/SuperAdmin";
import type { QueryPayload } from "@Front/Api/types";
import type { IGetFilesparams } from "../Files";
import { downloadMultipleFiles, downloadAggregatedCertificate as downloadAggregatedCertificateHelper } from "@Front/Api/LeCoffreApi/helpers/fileDownloadHelpers";
import { buildFilesDeletePayload } from "@Front/Api/LeCoffreApi/helpers/businessRequestPayloadHelpers";

export function createGetMethod(baseNotary: IBaseNotary, baseUrl: string) {
	return async (q: IGetFilesparams): Promise<File[]> => {
		const url = new URL(baseUrl);
		const query = { q };
		if (q) baseNotary.appendJsonSearchParams(url, query);
		try {
			const files = await baseNotary.getRequest<File[]>(url);
			return files;
		} catch (err) {
			baseNotary.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createGetByUidMethod(baseNotary: IBaseNotary, baseUrl: string) {
	return async (uid: string, q?: QueryPayload): Promise<File> => {
		const url = new URL(baseUrl.concat(`/${uid}`));
		const query = { q };
		if (q) baseNotary.appendJsonSearchParams(url, query);
		try {
			const file = await baseNotary.getRequest<File>(url);
			return file;
		} catch (err) {
			baseNotary.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createDeleteMethod(baseNotary: IBaseNotary, baseUrl: string) {
	return async (uid: string): Promise<File> => {
		const payload = buildFilesDeletePayload(uid);
		const url = new URL(baseUrl.concat(`/${payload.uid}`));
		try {
			return await baseNotary.deleteRequest<File>(url);
		} catch (err) {
			baseNotary.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createDownloadMethod(baseNotary: IBaseNotary, baseUrl: string) {
	return async (uid: string): Promise<Blob> => {
		const url = new URL(baseUrl.concat(`/download/${uid}`));
		try {
			return await baseNotary.getRequest<Blob>(url);
		} catch (err) {
			baseNotary.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createDownloadMultipleMethod(baseNotary: IBaseNotary, baseUrl: string) {
	return async (fileUids: string[], includeAnchors = true, folderNumber?: string, folderName?: string): Promise<Blob> => {
		return downloadMultipleFiles(baseNotary, baseUrl, { fileUids, includeAnchors, folderNumber, folderName });
	};
}

export function createDownloadAggregatedCertificateMethod(baseNotary: IBaseNotary, baseUrl: string) {
	return async (documentUids: string[], folderUid: string): Promise<Blob> => {
		return downloadAggregatedCertificateHelper(baseNotary, baseUrl, documentUids, folderUid);
	};
}
